export default "__VITE_ASSET__BDLYzJ_$__ 640w, __VITE_ASSET__JDoBfs6d__ 1024w, __VITE_ASSET__zeuibPy7__ 1536w";